module.exports = __webpack_public_path__ + "media/images/div_lens/Step2-793ee18382c7fb6813ed309604520ab8.png";